<script setup lang="ts">
    import { useCtUploadViewModel } from '@/views/case-settings/upload/ct/useCtUploadViewModel';
    import CtUploadZone from '@/views/case-settings/upload/ct/components/CtUploadZone.vue';
    import UploadedDetails from '@/views/case-settings/upload/ct/components/UploadedDetails.vue';

    import { useCaseSyncStore } from '@/stores/useCaseSyncStore';
    import { watch } from 'vue';

    const upload = useCtUploadViewModel();
    const caseSync = useCaseSyncStore();

    watch(() => upload.hasUploaded, async (hasUploaded) => {
        if (hasUploaded) {
            await caseSync.refresh();
        }
    });
</script>

<template>
    <app-notification
        v-if="upload.isError"
        title="Upload Failed"
        :message="upload.error"
        variant="error"
        :animate-to="true"
    />

    <div v-if="upload.hasEnteredPatientData && !upload.isCaseDeemedUnsuitable" class="ct-upload-container">
        <CtUploadZone />
    </div>

    <app-form-subtitle v-else-if="!upload.isCaseDeemedUnsuitable">
        Please enter all patient details, then return to this section to upload your CT Scan.
    </app-form-subtitle>

    <div v-if="upload.hasUploaded">
        <v-alert
            type="success"
            title="Your files were successfully uploaded"
            text="We will process your case now. Please return to the case list to track the progress of your case." />
    </div>

    <UploadedDetails />
</template>

<style scoped lang="scss">
    .ct-upload-container {
        margin: 0 50px 20px 50px;
    }

    @media screen and (max-width: 850px) {
        .ct-upload-container {
            margin: 0;
        }
    }
</style>
